import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { Modals } from 'components/Modals';
import { MODALS } from 'components/ModalsConfig';
import { navigationRef } from 'components/Navigation/navigationRef';
import {
  ModalScreens,
  NavigationStacks,
  Screens,
  Stacks,
} from 'components/Navigation/types';
import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import { Platform } from 'react-native';
import { useDispatch } from 'react-redux';
import { RepeatableStackScreen } from 'screens/AssessmentScreen/RepeatableStackScreen';
import { AssessmentScreen } from 'screens/AssessmentScreen/AssessmentScreen';
import { AuthScreen } from 'screens/AuthScreen/AuthScreen';
import { TabScreen } from 'screens/TabScreen/TabScreen';
import { SET_NAVIGATION_STATE } from 'store/actions';
import { selectNavigationState } from 'store/app/selectors';
import { TabError } from 'screens/TabError';

const Stack = createNativeStackNavigator<NavigationStacks[Stacks.ROOT]>();

export const RootNavigation: React.FC<{ onReady: () => void }> = ({
  onReady,
}) => {
  const dispatch = useDispatch();
  const navigationState = useSelector(selectNavigationState, () => true);
  return (
    <NavigationContainer
      ref={navigationRef}
      onReady={onReady}
      documentTitle={{
        enabled: false,
      }}
      initialState={navigationState}
      onStateChange={
        __DEV__ ? (state) => dispatch(SET_NAVIGATION_STATE(state)) : undefined
      }
    >
      <Stack.Navigator
        initialRouteName={Screens.ROOT_AUTH}
        screenOptions={{
          headerShown: false,
        }}
      >
        <Stack.Screen
          name={Screens.ROOT_AUTH}
          component={AuthScreen}
          options={{ animation: 'fade' }}
        />
        <Stack.Screen
          name={Screens.ROOT_TAB}
          component={TabScreen}
          options={{ animation: 'fade' }}
        />
        <Stack.Screen
          name={Screens.RootError}
          component={TabError}
          options={{ animation: 'fade' }}
        />
        <Stack.Screen
          name={Screens.ROOT_ASSESSMENT}
          component={AssessmentScreen}
        />
        <Stack.Screen
          name={Screens.ROOT_ASEREPEATABLE}
          component={RepeatableStackScreen}
        />
        {Object.entries(Platform.OS === 'ios' ? MODALS : {}).map(
          ([modalKey, modalProps]) => (
            <Stack.Screen
              name={ModalScreens[modalKey as ModalScreens]}
              key={modalKey}
              // component={modalProps.component}
              options={{
                gestureEnabled: !!modalProps.gestureEnabled,
                presentation:
                  modalProps.size === 'fullscreen'
                    ? 'transparentModal'
                    : modalProps.size === 'small'
                      ? 'formSheet'
                      : 'modal',
              }}
            >
              {(props) => <modalProps.component {...props} isModal />}
            </Stack.Screen>
          ),
        )}
      </Stack.Navigator>
      {Platform.OS !== 'ios' && <Modals />}
    </NavigationContainer>
  );
};
